<template>
    <div class="node">{{name}}
        <div class="popup">

        </div>
    </div>
</template>
<script>

    export default {
        name: 'node',
        data(){
            return {

            }
        },
        props: ['x', 'y', 'name'],
        created() {

        }
    }
    </script>